import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useWallet } from '~/lib/useWallet'
import { getVotingEscrowContract } from '~/contracts/getVotingEscrowContract'
import { BigNumber } from 'ethers'
import { DateTime } from 'luxon'
import { sisTokenKeys } from '~/lib/queryKeys'
import { useVESISParams } from '~/hooks/useVESISParams'

export function useCreateLock(value: BigNumber | undefined, duration: number) {
	const { config, provider } = useVESISParams()

	const { signer, account } = useWallet()

	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: async () => {
			if (!value || !duration) {
				return
			}

			const contract = getVotingEscrowContract(config, provider).connect(
				signer
			)

			const unlockTime = DateTime.now()
				.plus({ weeks: duration })
				.toUnixInteger()

			const tx = await contract.create_lock(
				value.toString(),
				unlockTime.toString()
			)

			await tx.wait()
		},
		onSuccess() {
			queryClient.resetQueries({
				queryKey: sisTokenKeys.balance(config.chain.id, account),
			})
			queryClient.resetQueries({ queryKey: ['sis-lock'] })
		},
		onError(error) {
			console.error('Error creating lock:', error)
		},
	})
}
